<template>
  <div class="block-promotions promotions">
    <div class="promotions__container container">
      <h2 class="promotions__title title">Акции Geely</h2>

      <div class="promotions__box">
        <div class="promotions__content content">
          <h3 class="content__title">
            <span>ВЫГОДА</span> ПО ПРОГРАММЕ <br />
            ТРЕЙД-ИН
          </h3>

          <button
            @click="
              getCall({
                type: 'sale',
                form: 'promotions',
                text: 'Получить выгоду',
              })
            "
            class="button content__button button_theme_primary"
          >
            Получить выгоду
          </button>
        </div>

        <img
          class="promotions__image"
          src="../images/promotions/cars.webp"
          alt="Машины Geely"
        />

        <button
          @click="
            getCall({
              type: 'sale',
              form: 'promotions',
              text: 'Получить выгоду',
            })
          "
          class="button promotions__button button_theme_primary"
        >
          Получить выгоду
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from "@/common/mixin";

export default {
  name: "BlockPromotions",
  mixins: [Mixin],
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.promotions {
  padding: calcFontSize(40, 38, 320, 1920) 0 calcFontSize(40, 68, 320, 1920);

  &__title {
    margin-bottom: calcFontSize(15, 67, 320, 1920);
  }

  &__box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__image {
    width: 100%;
    max-width: 762px;
  }

  &__content {
    display: flex;
    flex-direction: column;

    .content {
      &__title {
        color: $dark;
        font-size: calcFontSize(16, 36, 320, 1920);
        font-weight: 400;

        span {
          color: $red;
          font-weight: 700;
        }
      }

      &__button {
        margin-top: 17px;
        height: 50px;
        width: 318px;
      }
    }
  }

  &__button {
    display: none;
    height: 50px;
  }
}

@media (max-width: 720px) {
  .promotions {
    &__box {
      flex-direction: column;
      gap: 19px;
    }
    .content {
      &__title {
        text-align: center;
      }

      &__button {
        display: none;
      }
    }

    &__button {
      display: flex;
    }
  }
}
</style>
